import { apiClient } from 'shared/lib/apiClient';
import {
  PROFILE_PHOTO_REASONS,
  type ProfilePhotoReason,
} from 'features/courier-onboarding/types';

export interface ValidateProfilePhotoResult {
  accepted: boolean;
  url?: string;
  reasons: ProfilePhotoReason[];
}

const isReason = (value: unknown): value is ProfilePhotoReason =>
  typeof value === 'string' &&
  (PROFILE_PHOTO_REASONS as readonly string[]).includes(value);

/**
 * Asks the backend whether an uploaded profile photo is a close, clear face
 * with no glasses, helmet, or hat. Failure is a hard reject.
 */
export const validateProfilePhoto = async (
  url: string,
): Promise<ValidateProfilePhotoResult> => {
  try {
    const res = await apiClient.post<{
      accepted?: boolean;
      url?: string;
      reasons?: unknown;
    }>('/api/profile-photo/validate', { url }, { timeout: 60_000 });

    if (res.data.accepted === true && typeof res.data.url === 'string') {
      return { accepted: true, url: res.data.url, reasons: [] };
    }

    const reasons = Array.isArray(res.data.reasons)
      ? res.data.reasons.filter(isReason)
      : [];
    return {
      accepted: false,
      reasons: reasons.length > 0 ? reasons : ['check_unavailable'],
    };
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[HAAT CourierConnect] profile photo check failed', err);
    return { accepted: false, reasons: ['check_unavailable'] };
  }
};
